import schema, { generateType, } from './Schema';
export const EmailTemplate = generateType(schema.getModel('emailTemplate'));
export const sendTestEmailGql = /* GraphQL */ `
query sendTestEmail(
  $organizationID: String
  $portalID: String
  $customerID: String
  $subject: String
  $body: String
  $toEmail: String
  $fromEmail: String
  $bccEmails: String
) {
  sendTestEmail(
    organizationID: $organizationID
    portalID: $portalID
    customerID: $customerID
    subject: $subject
    body: $body
    toEmail: $toEmail
    fromEmail: $fromEmail
    bccEmails: $bccEmails
  ) {
      subject
      body
      result
  }
}
`;
//# sourceMappingURL=EmailTemplateModel.js.map